module.exports = __webpack_public_path__ + "static/media/plane(14).79ecee8b.PNG";